import React from "react";
import { useSelector } from "react-redux";

const ServiceTaken = () => {
  const customerDetail = useSelector((state) => state.customer.customerDetail);
  const services = useSelector((state) => state.service);

  // Combine all services into a single list
  const allServices = [
    ...services.abroad_counselling_list,
    ...services.test_prep_list,
    ...services.career_counselling_list,
    ...services.other_services_list,
  ];

  // Filter services taken by the customer
  const customerServices = allServices.filter((service) =>
    (customerDetail.subservice_name || []).includes(service.service_name)
  );

  return (
    <div className="p-6 bg-white rounded-lg h-full max-w-6xl mx-auto">
      <h2 className="text-2xl font-semibold mb-4">Services Taken</h2>
      <table className="table-auto w-full border-collapse border border-gray-300">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-300 px-4 py-2">#</th>
            <th className="border border-gray-300 px-4 py-2">Service Name</th>
            <th className="border border-gray-300 px-4 py-2">Country</th>
            <th className="border border-gray-300 px-4 py-2">Price</th>
          </tr>
        </thead>
        <tbody>
          {customerServices.length > 0 ? (
            customerServices.map((service, index) => (
              <tr key={service.id}>
                <td className="border border-gray-300 px-4 py-2">
                  {index + 1}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {service.service_name}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {service.country || "N/A"}
                </td>
                <td className="border border-gray-300 px-4 py-2">
                  {service.price ? `$${service.price}` : "N/A"}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                className="border border-gray-300 px-4 py-2 text-center"
                colSpan="4"
              >
                No services taken.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default ServiceTaken;
